import { Breadcrumbs, H5 } from '../../../../AbstractElements';
import TicketList from './TicketList';
import TicketTable from './TicketTable';
import { Card, CardBody, CardHeader, Col, Container, Row } from 'reactstrap';
import React, { Fragment } from 'react';
import i18n from '../../../../i18n';
import EmployeePerformance from './EmployeePerformance';

const SupportTickitContain = () => {
    return (
        <Fragment>
            <Breadcrumbs mainTitle={i18n.t('Dashboard_Breadcrumb_SupportTicket')} parent={i18n.t('Dashboard_Breadcrumb_Miscellaneous')} title={i18n.t('Dashboard_Breadcrumb_SupportTicket')} />
            <Container fluid={true}>
                <Row>
                    <Col sm="12">
                        <Card>
                            <CardHeader className="pb-0">
                                <H5>{i18n.t('Dashboard_Report_SupportListTitle')}</H5>
                                <span>{i18n.t('Dashboard_Report_SupportListDescription')}</span>
                            </CardHeader>
                            <CardBody>
                                <TicketList />
                                <TicketTable />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </Fragment>
    );
};
export { SupportTickitContain as LegacySupportTicketDemo };
export default EmployeePerformance;
